
export const isNode = typeof window === undefined


export function envFixed() {
    // 简单处理兼容node侧对象问题
    if (isNode) {
        ((global) => {
            global.window = {
                location: {},
                navigator:{},
                document:{},
            }
            global.location = global.window.location
            global.navigator = global.window.navigator
            global.document = global.window.document
        })(global || {})
    }
}
